import { render, staticRenderFns } from "./SetFare.vue?vue&type=template&id=304bd808&"
import script from "./SetFare.vue?vue&type=script&lang=js&"
export * from "./SetFare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports